import React from "react";
import axios from "axios";
import i18n from "i18next";
import {
  Table,
  Button,
  Input,
  DatePicker,
  Divider,
  Row,
  Col,
  Tag,
  Popconfirm,
  message,
} from "antd";
import { withRouter } from "react-router-dom";
import TaskForm from "./TaskForm";
import { withTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import "./style.css";

const { Search } = Input;
const { RangePicker } = DatePicker;
const ButtonGroup = Button.Group;

class TaskList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      modalTask: {},
      modalRequestType: "",
      // modalLoading: true,
      modalBtnText: "",
      modalVisible: false,
      modalTitleText: "",

      tags: [],
      users: [],
      contacts: [],
      status_list: [],
      priority_list: [],
      lead_list: [],
    };
    this.columns = [
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        sorter: true,
        // sorter: (a, b) => a.title.length - b.title.length,
        // sortDirections: ['descend', 'ascend'],
        // sortOrder: sortedInfo.columnKey === 'title' && sortedInfo.order,
        ellipsis: true,
      },
      {
        title: "Company name",
        dataIndex: "lead.name",
        key: "lead.name",
        ellipsis: true,
      },
      {
        title: "Phone",
        dataIndex: "lead.phone",
        key: "lead.phone",
        ellipsis: true,
      },
      {
        title: props.t("tasks.task_list.due_date", "Due date"),
        dataIndex: "due_date",
        key: "due_date",
        sorter: true,
        ellipsis: true,
      },
      {
        title: props.t("tasks.task_list.status", "Status"),
        dataIndex: "status_display",
        key: "status",
        sorter: true,
        ellipsis: true,
      },
      {
        title: props.t("tasks.task_list.priority", "Priority"),
        dataIndex: "priority_display",
        key: "priority",
        sorter: true,
        render: (text, record, index) => {
          if (record.priority) {
            let color = "";
            if (record.priority === "High") {
              color = "volcano";
            } else if (record.priority === "Medium") {
              color = "geekblue";
            } else {
              color = "green";
            }
            return (
              <Tag color={color}>{record.priority_display.toUpperCase()}</Tag>
            );
          }
        },
      },
      {
        title: props.t("general.actions", "Actions"),
        ellipsis: true,
        fixed: "right",
        render: (text, record, index) => (
          <span>
            <Button
              title={props.t("general.view", "View")}
              icon="eye"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                this.handlePreview(record);
              }}
            />
            <Button
              title={props.t("general.edit", "Edit")}
              style={{ marginLeft: "5px" }}
              type="primary"
              size="small"
              icon="edit"
              onClick={(e) => {
                e.stopPropagation();
                this.handleEditPreview(record);
              }}
            />
            <Popconfirm
              title={props.t(
                "tasks.task_list.task_delete",
                "Are you sure want to delete this task?"
              )}
              onConfirm={(event) => {
                event.stopPropagation();
                this.confirmDelete(event, record.id, index);
              }}
              placement="topLeft"
              okText={props.t("general.yes", "Yes")}
              cancelText={props.t("general.no", "No")}
              className="data-id={record.id}"
            >
              <Button
                size="small"
                onClick={(e) => e.stopPropagation()}
                title={props.t("general.delete", "Delete")}
                style={{ marginLeft: "5px" }}
                type="danger"
                icon="delete"
              />
            </Popconfirm>
          </span>
        ),
      },
    ];
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    // console.log(localStorage.getItem('language'));
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
    this.fetch();
  }

  fetch = (e) => {
    let requestList = [];
    requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/tags/"));
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/users_list/")
    );
    requestList.push(
      axios.get(process.env.REACT_APP_AXIOS_URL + "/api/contacts_list/")
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/choice_task_status_list/"
      )
    );
    requestList.push(
      axios.get(
        process.env.REACT_APP_AXIOS_URL + "/api/choice_task_priority_list/"
      )
    );
    // requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/leads_list/"));

    axios
      .all(requestList)
      .then(
        axios.spread((...responses) => {
          const responseTags = responses[0];
          const responseUsers = responses[1];
          const responseContacts = responses[2];
          const responseStatus = responses[3];
          const responsePriority = responses[4];
          const responseLeads = responses[5];
          this.setState({
            tags: responseTags.data,
            users: responseUsers.data,
            contacts: responseContacts.data,
            status_list: responseStatus.data,
            priority_list: responsePriority.data,
            // lead_list: responseLeads.data.results
          });
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.props.pagination };
    pager.current = pagination.current;

    let sorter_field = sorter.field;
    if (sorter_field && sorter_field.includes("display"))
      sorter_field = sorter_field.substring(0, sorter_field.length - 8);

    this.props.handleState("pagination", pager);
    this.props.handleState("sortedInfo", {
      order: sorter.order,
      columnKey: sorter_field,
    });
    this.props.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      sortField: sorter_field,
      sortOrder: sorter.order,
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  handleDeleteSelected = (event) => {
    this.props.handleState("loading", true);
    this.state.selectedRowKeys.filter((key, index) => {
      axios
        .delete(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${key}/delete/`)
        .then((res) => {
          if (res.status === 204 || res.status === 200) {
            return true;
          }
        });
    });

    let data = this.props.data;
    data = data.filter((item) => {
      return !this.state.selectedRowKeys.includes(item.id);
    });
    setTimeout(() => {
      this.props.handleState("data", data);
      this.props.handleState("loading", false);
      this.setState({
        selectedRowKeys: [],
      });
    }, 1000);
  };

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  handleSearch = (value) => {
    this.props.handleState("searchText", value);
    this.props.fetch({
      search: value,
      sortField: this.props.sortedInfo["columnKey"],
      sortOrder: this.props.sortedInfo["order"],
    });
  };

  handleDelete(taskID, recordID) {
    axios
      .delete(process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/delete/`)
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          this.props.reload();
          message.success(
            this.props.t("tasks.task_list.task_deleted", "Task deleted")
          );
        } else {
          message.warning(
            this.props.t(
              "tasks.task_list.task_deletion_failed",
              "Deletion failed"
            )
          );
        }
      });
  }

  confirmDelete(event, taskID, recordID) {
    event.preventDefault();
    this.handleDelete(taskID, recordID);
  }

  showModal = () => {
    this.formRef.resetFields();
    this.setState({
      modalVisible: true,
      modalTitleText: this.props.t(
        "tasks.task_list.modal_title_create",
        "Create a new task"
      ),
      modalRequestType: "post",
      modalBtnText: this.props.t("general.create", "Create"),
      modalTask: {},
    });
  };

  hideModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  handleCreate = () => {
    this.formRef.validateFields((err, values) => {
      if (err) {
        return;
      }

      const postObj = {
        ...values,
      };

      this.hideModal();
      axios
        .post(process.env.REACT_APP_AXIOS_URL + "/api/tasks/create/", postObj)
        .then((res) => {
          if (res.status === 201) {
            this.props.fetch();
            message.success(
              this.props.t(
                "tasks.task_list.task_created",
                "Task created successfully"
              )
            );
          }
        });

      this.formRef.resetFields();
    });
  };

  handlePreview = (modalTask) => {
    this.setState({
      modalTask,
      modalVisible: true,
      modalRequestType: "get",
      modalTitleText: this.props.t(
        "tasks.task_list.modal_title_preview",
        "Previewing a task"
      ),
    });
  };

  handleEditPreview = (modalTask) => {
    this.formRef.resetFields();
    this.setState({
      modalTask,
      modalBtnText: this.props.t("general.update", "Update"),
      modalVisible: true,
      modalRequestType: "put",
    });
  };

  handleEdit = (event) => {
    this.formRef.validateFields((err, values) => {
      if (err) {
        return;
      }

      const postObj = {
        ...values,
      };
      const taskID = this.state.modalTask.id;
      this.hideModal();
      axios
        .put(
          process.env.REACT_APP_AXIOS_URL + `/api/tasks/${taskID}/update/`,
          postObj
        )
        .then((res) => {
          if (res.status === 200) {
            this.props.fetch();
            message.success(
              this.props.t(
                "tasks.task_list.task_updated",
                "Task have been updated"
              )
            );
          }
        });

      // this.formRef.resetFields();
    });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
    // this.formRef = React.createRef();
  };

  selectedRows = () => {
    const { t } = this.props;
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      selections: [
        {
          key: "delete",
          text: t("general.delete", "Delete"),
          onSelect: this.handleDeleteSelected,
        },
      ],
    };
    return rowSelection;
  };

  render() {
    const { selectedRowKeys, users } = this.state;
    const { t } = this.props;
    const [s, p] = [this.state, this.props];
    let admins = users.filter((item) => item.role === "ADMIN");
    return (
      <div>
        <Row>
          <Col md={19}>
            <Button.Group size="default">
              <Button type="dashed" style={{ cursor: "default" }}>
                {t("leads.lead_form_sidebar.tasks", "Task")}
              </Button>
              <Button
                onClick={() => this.showModal()}
                icon="plus"
                type="primary"
              >
                {t("general.create", "Create")}
              </Button>
            </Button.Group>
            <Button
              icon="reload"
              loading={p.loading}
              onClick={() => p.read({}, {})}
              style={{ marginLeft: "5px" }}
            >
              Reload
            </Button>
            <ButtonGroup style={{ marginLeft: "10px" }}>
              <Button disabled>Due Date</Button>
              <RangePicker
                onChange={(e) => {
                  let params = {};
                  if (!isEmpty(e)) {
                    params = {
                      start_date: e[0].format("YYYY-MM-DD"),
                      end_date: e[1].format("YYYY-MM-DD"),
                    };
                  }
                  p.read({}, params, isEmpty(e));
                }}
              />
            </ButtonGroup>
          </Col>
          <Col md={5} style={{ textAlign: "end" }}>
            <Search
              size="default"
              placeholder={t("tasks.task_list.search", "Find task")}
              onSearch={(value) => this.handleSearch(value)}
              style={{ width: 200 }}
            />
          </Col>
          <Col span={24}>
            <Divider style={{ marginTop: "10px" }} />
          </Col>
        </Row>
        {/* <div className="to-do-header">
          <Search
            placeholder={t('tasks.task_list.search', "Find task")}
            onSearch={value => this.handleSearch(value)}
            style={{ width: 200, margin: 8 }}
          />
          <div style={{ float: 'right' }}>
            <Button style={{ margin: 8 }} type="primary" onClick={this.showModal}>
              <Icon type="plus" />
              {t('general.create', "Create")}
            </Button>
          </div>
        </div> */}
        <div className="to-do-content">
          <Table
            rowSelection={this.selectedRows()}
            columns={this.columns}
            onChange={this.handleTableChange}
            rowClassName="table-cursor"
            size="small"
            rowKey={(record) => record.id}
            dataSource={this.props.data}
            onRow={(record, rowIndex) => {
              return {
                // className: rowIndex % 2 === 1 ? 'odd' : '',
                onClick: (event) => this.handlePreview(record),
              };
            }}
            pagination={this.props.pagination}
            loading={this.props.loading}
          />
        </div>
        <TaskForm
          wrappedComponentRef={(form) => (this.formRef = form)}
          visible={s.modalVisible}
          onCancel={this.hideModal}
          btnText={this.state.modalBtnText}
          titleText={this.state.modalTitleText}
          handleState={this.handleState}
          requestType={this.state.modalRequestType}
          data={this.state.modalTask}
          fetch={this.props.fetch}
          tags={this.state.tags}
          users={admins}
          contacts={this.state.contacts}
          status_list={this.state.status_list}
          priority_list={this.state.priority_list}
          // lead_list={this.state.lead_list}
        />
      </div>
    );
  }
}

export default withRouter(withTranslation()(TaskList));



// WEBPACK FOOTER //
// ./src/containers/Tasks/TaskList.js